query getPositions($where: JSON, $locked: Boolean) {
    getPositions(where: $where, locked: $locked) 
}